import { Emprunt } from '../../types';

/**
 * @french
 * État initial du slice des exercices.
 */
export const empruntsInitialState = {
  selectedEmprunt: null as Emprunt | null,
  activeTabKey: '1' as string,
  empruntVersion: 0 as number,
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type EmpruntsState = typeof empruntsInitialState;
